export default __webpack_public_path__ + "static/media/icon_wallet.1d9ac3e4.svg";